import { Box } from "../../box";
import { forwardRef } from "react";
import { cssModule, isNil, isNumber, mergeProps, useAutoFocus, useCheckableProps, useControllableState, useEventCallback, useMergedRefs } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { useTile } from "./useTile";
import { jsx as _jsx } from "react/jsx-runtime";
const DefaultElement = "button";
export function InnerTile(props) {
  const [checkableProps, isCheckable] = useCheckableProps(props);
  const {
    active,
    as = DefaultElement,
    autoFocus,
    checked,
    children,
    defaultChecked,
    focus,
    forwardedRef,
    hover,
    onChange,
    onCheck,
    orientation = "vertical",
    value,
    ...rest
  } = mergeProps(props, checkableProps);
  const orientationValue = useResponsiveValue(orientation);
  const [isChecked, setIsChecked] = useControllableState(checked, defaultChecked, false);
  const ref = useMergedRefs(forwardedRef);
  const handleClick = useEventCallback(event => {
    setIsChecked(!isChecked);

    if (!isNil(onCheck)) {
      onCheck(event, value);
    }

    if (!isNil(onChange)) {
      onChange(event, !isChecked);
    }
  });
  const {
    markup,
    tileProps
  } = useTile({
    active,
    children,
    focus,
    hover,
    orientation: orientationValue,
    variant: "checkable"
  });
  useAutoFocus(ref, {
    delay: isNumber(autoFocus) ? autoFocus : undefined,
    isDisabled: !autoFocus
  });
  return /*#__PURE__*/_jsx(Box, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-tile"),
      onClick: handleClick,
      [isCheckable ? "aria-checked" : "aria-pressed"]: isChecked,
      ref,
      value
    }, tileProps),
    children: markup
  });
}
InnerTile.defaultElement = DefaultElement;
export const Tile = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerTile, { ...props,
  forwardedRef: ref
}));